"use client";

import ThemeTogglerTwo from "@/components/common/ThemeTogglerTwo";
import GradientLogo from "@/components/ui/GradientLogo";

import { ThemeProvider } from "@/context/ThemeContext";
import { getStoredBrandTheme } from "@/utils/storage/safeLocalStorage";
import Link from "next/link";
import React, { useState, useEffect } from "react";

export default function SignInLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [brandTheme, setBrandTheme] = useState<'v1' | 'v2'>('v2'); // Default to v2

  useEffect(() => {
    // Requirements summary: unavailable browser storage should not block sign-in.
    if (getStoredBrandTheme() === 'v1') {
      setBrandTheme('v1');
    }
  }, []);

  return (
    // Requirements summary: mobile auth pages use normal document scrolling
    // like the catalog/register flow; desktop keeps the fixed split-screen shell.
    <div className="relative min-h-screen p-6 bg-white z-1 dark:bg-gray-900 sm:p-0 lg:h-screen lg:overflow-hidden">
      <ThemeProvider>
        <div className="relative flex lg:flex-row w-full justify-center flex-col dark:bg-gray-900 sm:p-0 lg:h-full">
          {children}
          <div className="lg:w-1/2 w-full h-full bg-brand-gradient-dark dark:bg-white/5 lg:grid items-center hidden">
            <div className="relative items-center justify-center flex z-1">
              <div className="flex flex-col items-center max-w-xs">
                <Link href="/" className="block mb-4">
                  <GradientLogo 
                    variant="full" 
                    width={280}
                    height={58}
                    useGradient={brandTheme === 'v2'}
                  />
                </Link>
                <p className="text-center text-white/70">
                  Elite teams need elite coordination
                </p>
              </div>
            </div>
          </div>
          <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
            <ThemeTogglerTwo />
          </div>
        </div>
      </ThemeProvider>
    </div>
  );
} 
